// extracted by mini-css-extract-plugin
export default {"container":"About_container__WazHV","title_heading_container":"About_title_heading_container__WZURr"};